/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Subtext_Not_Your_FaultInputs */



/**
* | output |
* | --- |
* | "Something broke and it's definitely not your fault." |
*
* @param {Error_Subtext_Not_Your_FaultInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_subtext_not_your_fault = /** @type {((inputs?: Error_Subtext_Not_Your_FaultInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Subtext_Not_Your_FaultInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Etwas ist kaputt und es liegt definitiv nicht an dir.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quelque chose a cassé et ce n'est vraiment pas votre faute.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("出了点问题，这绝对不是你的错。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("有東西壞掉了，而且絕對不是你的錯。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("무언가 망가졌지만 회원님 잘못은 절대 아닙니다.")
	return /** @type {LocalizedString} */ ("Something broke and it's definitely not your fault.")
});